import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { SignalBinding } from "signals";
import { HideAllLinesCommand } from "slotworks/commands/lines/hide-all-lines-command";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";

export interface IdleConfig {
    holdSpinDelay: number;
}

export class Idle extends State {

    protected signalBindings: SignalBinding[] = [];

    protected config: IdleConfig = {
        holdSpinDelay: 0
    };

    private holdSkipTimer: number;

    constructor(config?: Partial<IdleConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public onEnter() {
        uiFlags.set(UIFlag.IDLE, true);

        this.signalBindings.push(Services.bet.onBetChange.add(() => this.onBetChange()));

        Services.transaction.setBalance(gameState.getCurrentGame().balance);
    }

    public onSkip() {
        if (!this.holdSkipTimer) {
            // TODO: V3: Fix preferebly to not have reference to control
            // if (HoldSpinControl.isHeld) {
            //     this.holdSkipTimer = Timer.setTimeout(() => {
            //         this.holdSkipTimer = null;
            //         this.skip();
            //     }, Idle.HOLD_SPIN_DELAY);
            // } else {
            this.skip();
            // }
        }
    }

    public onExit() {
        Components.get(AbstractMatrixComponent)?.resetSymbols();

        HideAllLinesCommand().execute();

        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.GAME_IN_PROGRESS, true);
        uiFlags.closeMenus();
    }

    public skip(): void {
        this.clearSignalBindings();
        super.skip();
    }

    public complete(): void {
        this.clearSignalBindings();
        super.complete();
    }

    protected clearSignalBindings(): void {
        for (const binding of this.signalBindings) {
            binding.detach();
        }

        this.signalBindings = [];
    }

    protected onBetChange(): void {
        Services.transaction.setTotalWin(0);
    }
}
